import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LightningBoltIcon from '@heroicons/react/outline/LightningBoltIcon';
import { Divider } from '@tribeplatform/react-ui-kit/Divider';
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown';
import { useStaticIntl } from '../../i18n';
import { useComposerConfig } from '../ComposerConfigContext';
import { slashMenuItemsFactory } from '../extensions/slash-menu/items';
import { ComposerIconButton } from './ComposerIconButton';
export const SlashMenuButton = ({ onItemClick, size, }) => {
    const { extensions } = useComposerConfig();
    const getItems = useStaticIntl(slashMenuItemsFactory);
    const items = getItems(extensions);
    return (_jsx("div", { children: _jsxs(Dropdown, { children: [_jsx(Dropdown.ButtonMinimal, { as: "div", children: _jsx(ComposerIconButton, { size: size, icon: LightningBoltIcon, "aria-label": "Options" }, void 0) }, void 0), _jsx(Dropdown.Items, { className: "overflow-auto overflow-y-scroll", style: { maxHeight: '236px' }, children: items.map((item, index) => {
                        if (item.type === 'divider') {
                            // eslint-disable-next-line react/no-array-index-key
                            return _jsx(Divider, { padding: "sm" }, `divider-${index}`);
                        }
                        return (_jsx(Dropdown.Item, { onClick: () => onItemClick(item), leadingIcon: _jsx("div", { className: "w-4 h-4 flex items-center", children: item.icon }, void 0), children: item.label }, item.label));
                    }) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=SlashMenuButton.js.map